import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import RequestForSignetApprovalForm from './CreationForm/RequestForSignetApprovalForm';
import {
  findAllPlaceByAutonomousProvince,
  findAllPlaceWithoutAutonomousProvince,
  clearPlaceList,
  findAllPlace,
} from '../../actions/place';
import {
  findAllMunicipalityByPlace,
  clearMunicipalityList,
} from '../../actions/municipality';
import { findAllInstitutionType } from '../../actions/institutionType';
import { findAllKjsByInstitutionType, clearKjsList } from '../../actions/kjs';
import { findUserById } from '../../actions/user';

class ModalForAddRequestForSignetApproval extends React.Component {
  handleClose = () => {
    this.props.handleClose();
  };

  componentDidMount() {
    this.props.findAllPlace();
    this.props.findAllInstitutionType();
  }

  render() {
    const { findUserById, user } = this.props || {};
    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <RequestForSignetApprovalForm
              autonomousProvinceList={this.props.autonomousProvinceList}
              placeList={this.props.placeList}
              municipalityList={this.props.municipalityList}
              kjsList={this.props.kjsList}
              institutionTypeList={this.props.institutionTypeList}
              findAllPlaceByAutonomousProvince={
                this.props.findAllPlaceByAutonomousProvince
              }
              findAllMunicipalityByPlace={this.props.findAllMunicipalityByPlace}
              findAllKjsByInstitutionType={
                this.props.findAllKjsByInstitutionType
              }
              findAllPlaceWithoutAutonomousProvince={
                this.props.findAllPlaceWithoutAutonomousProvince
              }
              clearPlaceList={this.props.clearPlaceList}
              clearMunicipalityList={this.props.clearMunicipalityList}
              clearKjsList={this.props.clearKjsList}
              handleAdd={this.props.handleAdd}
              changeRequestForSignetApprovalStatus={
                this.props.changeRequestForSignetApprovalStatus
              }
              findAllPlace={this.props.findAllPlace}
              handleClose={this.props.handleClose}
              loggedUser={this.props.loggedUser}
              findUserById={findUserById}
              user={user}
            />
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  autonomousProvinceList: state.autonomousProvince.autonomousProvinceList || [],
  placeList: state.place.placeList || [],
  municipalityList: state.municipality.municipalityList || [],
  kjsList: state.kjs.kjsList || [],
  institutionTypeList: state.institutionType.institutionTypeList || [],
  user: state.user.user,
  loggedUser: state.loggedUser.loggedUser,
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllPlaceWithoutAutonomousProvince: () => {
      dispatch(findAllPlaceWithoutAutonomousProvince());
    },
    findAllPlaceByAutonomousProvince: (autonomousProvinceId) => {
      dispatch(findAllPlaceByAutonomousProvince(autonomousProvinceId));
    },
    findAllMunicipalityByPlace: (placeId) => {
      dispatch(findAllMunicipalityByPlace(placeId));
    },
    findAllInstitutionType: () => {
      dispatch(findAllInstitutionType());
    },
    findAllKjsByInstitutionType: (institutionTypeId) => {
      dispatch(findAllKjsByInstitutionType(institutionTypeId));
    },
    clearPlaceList: () => {
      dispatch(clearPlaceList());
    },
    clearMunicipalityList: () => {
      dispatch(clearMunicipalityList());
    },
    clearKjsList: () => {
      dispatch(clearKjsList());
    },
    findAllPlace: () => {
      dispatch(findAllPlace());
    },
    findUserById: (userId) => {
      dispatch(findUserById(userId));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalForAddRequestForSignetApproval);
